
import { defineComponent } from 'vue'
import ServicesHeroSection from '@/components/mt-clickbait-parts/Hero.vue'
import Scrollable from '@/components/mt-clickbait-parts/Scrollable.vue'
import Testimonials from '@/components/mt-clickbait-parts/Testimonials.vue'
import ServicesContactForm from '@/components/components-services/ServicesContactForm.vue'
import ServicesFooter from '@/components/components-services/ServicesFooter.vue'

export default defineComponent({
  name: 'MTClickbaitView',
  components: {
    ServicesHeroSection,
    Scrollable,
    Testimonials,
    ServicesContactForm,
    ServicesFooter,
  },
  computed: {
    servicesInfo() {
      return [
        {
          id: 1,
          label: this.$t('landingMTClickbait.services.video.label') as string,
        },
        {
          id: 2,
          label: this.$t('landingMTClickbait.services.static.label') as string,
        },
        {
          id: 3,
          label: this.$t('landingMTClickbait.services.uiux.label') as string,
        },
        {
          id: 4,
          label: this.$t(
            'landingMTClickbait.services.whiteBusiness.label',
          ) as string,
        },
        {
          id: 5,
          label: this.$t(
            'landingMTClickbait.services.socialDesign.label',
          ) as string,
        },
        {
          id: 6,
          label: this.$t('landingMTClickbait.services.editing.label') as string,
        },
        {
          id: 7,
          label: this.$t('landingMTClickbait.services.funnel.label') as string,
        },
        {
          id: 8,
          label: this.$t(
            'landingMTClickbait.services.deepfake.label',
          ) as string,
        },
      ]
    },
    firstHalf() {
      const middleIndex = Math.ceil(this.servicesInfo.length / 2)
      return this.servicesInfo.slice(0, middleIndex)
    },
    secondHalf() {
      const middleIndex = Math.ceil(this.servicesInfo.length / 2)
      return this.servicesInfo.slice(middleIndex)
    },
    leftItems() {
      return [
        {
          id: 1,
          label: this.$t(
            'landingMTClickbait.why_us_section.experience.label',
          ) as string,
        },
        {
          id: 2,
          label: this.$t(
            'landingMTClickbait.why_us_section.freeRounds.label',
          ) as string,
        },
        {
          id: 3,
          label: this.$t(
            'landingMTClickbait.why_us_section.support.label',
          ) as string,
        },
      ]
    },
    rightItems() {
      return [
        {
          id: 4,
          label: this.$t(
            'landingMTClickbait.why_us_section.templates.label',
          ) as string,
        },
        {
          id: 5,
          label: this.$t(
            'landingMTClickbait.why_us_section.bestPrices.label',
          ) as string,
        },
        {
          id: 6,
          label: this.$t(
            'landingMTClickbait.why_us_section.fastWork.label',
          ) as string,
        },
      ]
    },
  },
})
